import Image from '@components/Image';
import Indicator from '@components/Indicator';
import styled from '@emotion/styled';
import { useContext } from 'react';

import PpCardListContext
    from './context/PpCardListContext';
import usePpCardPages from './hooks/usePpCardPages';

const GRID_COUNT = 6;

function CardGrid() {
    const cardPage = usePpCardPages();
    const { setIndicator, swiper, indicator } = useContext(PpCardListContext);
    return (
        <Container>
            <Contents onScroll={(e) => {
                const { scrollLeft, offsetWidth } = e.currentTarget;
                setIndicator(Math.round(scrollLeft / offsetWidth));
            }}>
                {cardPage.map((page, i) => (
                    <Grid key={i}>
                        {page.map((card, j) => (
                            <SmImage src={card.imageUrl}
                                key={`small ${i} ${j}`}
                                width={72}
                                height={48}
                                alt={i.toString()}
                                onClick={() => {
                                    if (swiper && ('slideTo' in swiper)) {
                                        swiper?.slideTo(i * GRID_COUNT + j);
                                    }
                                }}
                            />
                        ))}
                    </Grid>
                ))}
            </Contents>
            {cardPage.length >= 2 && (
                <IndicatorWrapper >
                    <Indicator total={cardPage.length} current={indicator} />
                </IndicatorWrapper>
            )}
        </Container>
    );
}

const Container = styled.div`
    border-radius: 6px;
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.14);
    width: calc(100% - 40px);
`;

const Contents = styled.div`
    display: flex;
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
    width: 100%;
    &::-webkit-scrollbar {
        display: none;
    }
`;

const Grid = styled.div`
    display: grid;
    gap: 14px;
    grid-template-columns: repeat(3, 1fr);
    min-width: 100%;
    padding: 26px 38px;
    scroll-snap-align: start;
    scroll-snap-stop: always;
    width: 100%;
`;

const IndicatorWrapper = styled.div`
    display: flex;
    justify-content: center;
    padding: 24px 0;
`;

const SmImage = styled(Image)`
    aspect-ratio: 1.5;
    border-radius: 8px;
    height: auto;
    width: 100%;
`;

export default CardGrid;
